import { Pipe, PipeTransform } from '@angular/core';

/**
 * Angular pipe to format numbers as millions ('M') or thousands ('K').
 * Handles null, undefined, negative, and non-numeric inputs gracefully.
 * Usage: {{ value | MillionsToMThousandsToK }}
 */
@Pipe({ name: 'MillionsToMThousandsToK' })
export class MillionsToMThousandsToK implements PipeTransform {
  
  /**
   * Helper function to add commas to a number string for US formatting
   * @param numStr - The number string to format
   * @returns The formatted string with commas
   */
  private addCommas(numStr: string): string {
    const parts = numStr.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  transform(value: number | null | undefined): string {
    if (value == null || typeof value !== 'number' || isNaN(value)) return '0';
    
    if (Math.abs(value) < 1000) {
      return this.addCommas(value.toString());
    }
    if (Math.abs(value) < 1_000_000) {
      const kValue = (value / 1_000).toFixed(2).replace(/\.00$/, '');
      return this.addCommas(kValue) + 'K';
    }
    const mValue = (value / 1_000_000).toFixed(2).replace(/\.00$/, '');
    return this.addCommas(mValue) + 'M';
  }
}